<template>
  <el-dialog
    append-to-body
    destroy-on-close
    width="550px"
    title=""
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-loading="loading"
    element-loading-text="图片上传中…"
  >
    <template #title>
      <div class="el-dialog-title">转交</div>
    </template>
    <el-form
      class="staff-from"
      ref="elFormDom"
      label-width="80px"
      label-position="top"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
      hide-required-asterisk
    >
      <el-form-item label="" prop="comment">
        <template #label> 转交人 </template>
        <employeselect
          v-model="form.data.employee_id"
          ref="employeselect"
        ></employeselect>
      </el-form-item>
      <el-form-item label="" prop="comment">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model.trim="form.data.comment"
          placeholder="请输入转交原因"
          clearable
        ></el-input>
      </el-form-item>
      <aiTe ref="aiTeRef" v-model="aiteIdList" @change="aiTeChange"></aiTe>
      <div :class="{'padding-b10':aiteObjList.length}">
        <el-tag size="small" v-for="tag in aiteObjList" @close="tagClose(tag.id)" :key="tag.name" closable>
          {{ tag.name }}
        </el-tag>
      </div>
      <el-form-item label="附件" prop="file">
        <template #label> 附件 <span style="color: #999"></span> </template>
        <uploadfile
          :loading.sync="form.loading"
          :fileList="fileList"
          @setfileList="(files) => (fileList = files)"
        ></uploadfile>
      </el-form-item>
      <el-form-item label="" prop="image" class="imgWrap">
        <template #label>
          图片 <span style="color: #999">(最多选择9张图片)</span>
        </template>
        <uploadimg
          :loading.sync="form.loading"
          :fileListImg="fileListImg"
          @imgChange="(files) => (fileListImg = files)"
        ></uploadimg>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading.sync="form.loading"
          :disabled="form.loading"
          @click="submitForm"
          >完成</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import { getStorage } from "@/storage";
import uploadfile from "@/components/uploadfile.vue";
import uploadimg from "@/components/uploadimg.vue";
import employeselect from "@/components/employeselect.vue";
import aiTe from "@/components/aiTe.vue";
export default {
  name: "MyComment",
  mixins: [mixinTable],
  components: { uploadfile, uploadimg, employeselect, aiTe },
  data() {
    return {
      token: getStorage("token"),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          id: "",
          comment: "",
          picture: [],
          files: [],
          employee_id: "",
        },
        rules: {},
      },
      fileList: [],
      fileListImg: [],
      str: ["同意", "确认", "情况属实", "已复核", "已办理"],
      checkboxGroup1: [],
      employee_id: "",
      aiteIdList:[],
      aiteObjList:[],
    };
  },
  methods: {
    tagClose(id) {
      this.aiteIdList = this.aiteIdList.filter((item) => item !== id);
      this.aiteObjList = this.aiteObjList.filter((item) => item.id !== id);
      this.$refs.aiTeRef.personObjList = this.aiteObjList;
    },
    change(e) {
      this.form.data.comment = e;
    },
    getDetail(row, id) {
      if (!!row.id) {
        this.isChange = true;
        this.$nextTick(() => {
          this.form.data.id = id;
        });
      }
    },
    reset(done) {
      this.isChange = false;
      this.fileList = [];
      this.fileListImg = [];
      this.aiteIdList = [];
      this.aiteObjList = [];
      this.$refs.employeselect.reset();
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    aiTeChange(val) {
      this.aiteObjList = val;
      console.log('收到','aiteObjList',this.aiteObjList)
    },
    // 提交
    submitForm() {
      console.log(this.aiteObjList,'aiteObjList')
      console.log(this.aiteIdList,'aiteIdList')
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let _fileList = this.fileList.map((v) => {
            return {
              name: v.name,
              file: v.url,
            };
          });
          let _fileListImg = this.fileListImg.map((v) => v.url);
          if (!this.form.data.employee_id)
            return this.$message.warning("请选择转交人");
          if (
            _fileList.length == 0 &&
            _fileListImg.length == 0 &&
            this.form.data.comment == ""
          ) {
            return this.$message.warning("请输入转交原因");
          }
          let at_employees = this.aiteObjList.length>0?this.aiteObjList.map(item => {
              return {
                employee_id:item.id,
                name:item.name
              }
            }):[]
          let _params = {
            id: this.form.data.id,
            comment: this.form.data.comment,
            picture: JSON.stringify(_fileListImg),
            files: JSON.stringify(_fileList),
            employee_id: this.form.data.employee_id,
            at_employees:JSON.stringify(at_employees)
          };
          if(at_employees.length) {
            let str = '';
            at_employees.forEach(e => {
              str += `@${e.name} `
            });
            _params.comment = str +' ' +this.form.data.comment;
          }
          this.form.loading = true;
          this.$http
            .post("/admin/employeeApproval/turnOver", _params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.imgWrap ::v-deep .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.imgWrap ::v-deep .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}
.imgWrap ::v-deep .avatar-uploader-icon {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.padding-b10{
  padding-bottom: 10px;
}
</style>